export type ReferrerBadgeLevel = 'new' | 'active' | 'top' | 'elite';

export interface ReferrerRating {
  total_referrals: number;
  successful_hires: number;
  success_rate: number;
  total_earned: number;
  badge: ReferrerBadgeLevel;
}

export const getBadgeLevel = (totalReferrals: number, successRate: number): ReferrerBadgeLevel => {
  if (totalReferrals >= 10 && successRate >= 50) return 'elite';
  if (totalReferrals >= 5 && successRate >= 30) return 'top';
  if (totalReferrals >= 3) return 'active';
  return 'new';
};
